import React from 'react';
import { IAuthLayoutProps } from 'store/ducks/Global/types';
import * as Styled from 'components/Layouts/AuthLayout/AuthLayout.styled';

const AuthLayout: React.FC<IAuthLayoutProps> = ({ children }) => (
  <Styled.StyledContainer>
    <Styled.LoginLogo />
    <Styled.HeroTextContainer>
      <Styled.MainHeading>Make Compliance Manageable</Styled.MainHeading>
      <Styled.SubHeading>
        From Regulation to Audit-Ready Evidence. Risks and Controls in Context.
      </Styled.SubHeading>
    </Styled.HeroTextContainer>
    <Styled.FormContainer>{children}</Styled.FormContainer>
  </Styled.StyledContainer>
);

export default AuthLayout;
